import axios from "axios";
import { ServerGridConfig } from "../../config/GridConfig";
import RootStore from "../RootStore/RootStore";
import API_URL from "../../config/ApiUrl";
import { makeAutoObservable } from 'mobx';

export default class PaymentStore {
	list_data = null;
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	searchValue = '';
	merchantId = '';
	propertyId = '';
	propertyList = [];

	constructor() {
		makeAutoObservable(this);
		this.rootStore = new RootStore();
	}

	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if(this.agGrid) {
			this.agGrid.api.paginationPageSize(parseInt(page));
		}
	};

	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			// called by the grid when more rows are required
			getRows: (params) => {
				// get data for request from server
				const payload = this.rootStore.getServerListPayload(
					params,
					this.searchValue,
				);
				this.getList({
					...payload,
					merchantId: this.merchantId,
					propertyId: this.propertyId
				})
					.then(({ data, totalRecords }) => {
						if (totalRecords === 0) {
							this.agGrid.api.showNoRowsOverlay();
						} else {
							this.agGrid.api.hideOverlay();
						}
						params.success({
							rowData: data,
							rowCount: totalRecords,
						});
					})
					.catch((err) => {
						params.fail(err);
					});
			},
		};
	};

	getList = async (payload) => {
		try {
			const { data } = await axios.get(
				`${API_URL.PAYMENT.LIST}?pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&sortBy=${payload.sortBy}&searchValue=${encodeURIComponent(payload.searchValue)}&isActive=1&propertyId=${encodeURIComponent(payload.propertyId)}&merchantId=${encodeURIComponent(payload.merchantId)}`
			);
			return data.data;
		} catch {}
	};

	getMerchantwisePropertyList = async (merchantId) => {
		try {
			const { data } = await axios.get(`${API_URL.PAYMENT.PROPERTYLOOKUP}?merchantId=${encodeURIComponent(merchantId)}`);
			this.propertyList = data.data ?? [];
			return data.data;
		} catch {}
	};
}